import { formatNumber } from "./formatNumber";

export const displaySum = (props: { value?: number | null; currency: string }) => {
  return `${formatNumber(props.value ?? 0)} ${props.currency}`;
};
